import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface ResumeConsultResponse {
  consultId: number;
  sessionId: string;
  assignedProvider: string;
  unitDepartment: string;
  status: string;
  reasonForConsult: string;
}

export interface ResumeResponse {
  code: number;
  status: string;
  message: string;
}

export const getResumeConsults = async (
  userId: number,
  sessionId: string
): Promise<ResumeConsultResponse[]> => {
  const response = await httpRequest<ResumeConsultResponse[]>({
    url: `facility/facility-user/${userId}/resume-consults?sessionId=${sessionId}`,
    method: 'GET',
  });
  return response;
};

export const resumeSelectedConsults = async (
  userId: number,
  consultId: number
): Promise<ResumeResponse> => {
  const response = await httpRequest<ResumeResponse>({
    url: `facility/facility-user/${userId}/resume-consults?consultId=${consultId}`,
    method: 'POST',
    withCredentials: true,
  });
  return response;
};
